// Deep-link do modal "Baixe o aplicativo" (ENG-495): `?open=modal-aplicativo`.
// Mesmo desenho dos outros `?open=` do layout (roleta, promocode, check-in): o
// layout reconhece o valor, manda a store abrir e limpa a URL.
export const APP_DOWNLOAD_QUERY_VALUES = ['modal-aplicativo'];

export function isAppDownloadOpenParam(value: unknown): boolean {
  const first = Array.isArray(value) ? value[0] : value;

  return typeof first === 'string' && APP_DOWNLOAD_QUERY_VALUES.includes(first);
}

// Deep-link do cartaz do bônus app-only (ENG-799): `?open=modal-bonus-app`.
// Valor separado, e não mais uma grafia do de cima, porque são dois cartazes
// diferentes: este é o convite do bônus resgatável só pelo app.
export const APP_DOWNLOAD_BONUS_QUERY_VALUES = ['modal-bonus-app'];

export function isAppDownloadBonusOpenParam(value: unknown): boolean {
  const first = Array.isArray(value) ? value[0] : value;

  return (
    typeof first === 'string' && APP_DOWNLOAD_BONUS_QUERY_VALUES.includes(first)
  );
}

// OneLinks da AppsFlyer, um por BOTÃO de cada cartaz (criados à mão no
// dashboard, não pela Ferramenta de Tráfego).
//
// Por que um por botão, e não um por cartaz: o destino de desktop é um campo
// único do link. Com um link só, os dois botões dividiriam o mesmo destino e
// quem clicasse em "Baixar na App Store" num Mac cairia na Play. No celular os
// dois se comportam igual — lá quem decide a loja é a plataforma.
//
// Os links da Ferramenta de Tráfego não serviam aqui porque o gerador sempre
// crava `af_web_dp` com o próprio site, e ele SOBREPÕE o destino de desktop do
// template: o clique no PC abria uma aba nova e caía onde a pessoa já estava.
// Criados no dashboard, cada link aponta o desktop para a ficha da sua loja.
//
// A campanha (`c`) de cada par identifica o cartaz na atribuição:
// `modal_app_generico`, `modal_bonus_app` e `parede_pwa`. O do bônus leva
// `deep_link_value=/user/rewards`, então quem instala por ele abre o app já na
// tela de resgate.
export const APP_DOWNLOAD_LINKS = {
  genericModal: {
    googlePlay: 'https://go.apostatudo.bet.br/hCkd/t4jpjte3',
    appStore: 'https://go.apostatudo.bet.br/hCkd/fsapoh99',
  },
  bonusModal: {
    googlePlay: 'https://go.apostatudo.bet.br/hCkd/gt265c49',
    appStore: 'https://go.apostatudo.bet.br/hCkd/uh53z1fe',
  },
  pwaWall: {
    googlePlay: 'https://go.apostatudo.bet.br/hCkd/fj0f9lxp',
    appStore: 'https://go.apostatudo.bet.br/hCkd/iwmd7ex1',
  },
} as const;

export type AppDownloadLinks =
  (typeof APP_DOWNLOAD_LINKS)[keyof typeof APP_DOWNLOAD_LINKS];
